import React from 'react';
import { Card, CardActionArea, CardMedia, Chip, Box, Typography, Grid, Avatar, CardContent, CardActions } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import PoolCardStyle from './PoolsStyle';

const SkeletonCardClosed = () => {

    const classes = PoolCardStyle();

    return (
        <Card variant="outlined" className={classes.skeleton}>
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                className={classes.iconWrapperClosed}
            >
                <Grid
                    item
                >
                    <Grid
                    container
                    >
                        <Grid item>
                            <Skeleton variant="circle" className={classes.avatarClosed} />
                        </Grid>
                        <Grid 
                            item
                            style={{
                                marginLeft: "15px",
                            }}
                        >
                            <Typography>
                                <Skeleton variant="text" width={100} />
                            </Typography>
                            <Typography>
                                <Skeleton variant="text" width={100} />
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <Skeleton variant="circle" className={classes.network} />
                </Grid>
            </Grid>
            <CardContent className={classes.contentClosed}>
                <Grid
                    container
                    direction="column"
                    className={classes.detailContainerClosed}
                >
                    <Grid item>
                        <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Grid item>
                                <Typography>
                                    <Skeleton variant="text" width={100} />
                                </Typography>
                            </Grid>
                            <Grid item xs={true}>
                                <Box border={"1px #ECF0F3 dashed"} marginX={"18px"}></Box>
                            </Grid>
                            <Grid item>
                                <Skeleton variant='text' width={100} />
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Grid item>
                                <Typography>
                                    <Skeleton variant="text" width={100} />
                                </Typography>
                            </Grid>
                            <Grid item xs={true}>
                                <Box border={"1px #ECF0F3 dashed"} marginX={"18px"}></Box>
                            </Grid>
                            <Grid item>
                                <Skeleton variant='text' width={100} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}

export default SkeletonCardClosed;
